module.exports = __webpack_public_path__ + "static/footer_logo-1.0.0.png";